import React from 'react';
import WoocommerceAPI from '../../../components/IPSAPI/WoocommerceAPI';
import store from '../store/checkoutStore.ts';  //Todo-ips änderung ts js
import { setAllCartData } from '../actions/cartactions/fetchdirectActions';


class UpdateSideCart {
    private supportsHTML5Storage: boolean;
    

    constructor() {
        // Überprüfe, ob HTML5-Speicher unterstützt wird
        try {
            this.supportsHTML5Storage = ('sessionStorage' in window && window.sessionStorage !== null);
            window.sessionStorage.setItem('wc', 'test');
            window.sessionStorage.removeItem('wc');
            window.localStorage.setItem('wc', 'test');
            window.localStorage.removeItem('wc');
        } catch (err) {
            this.supportsHTML5Storage = false;
        }
    }

    /**
     * Aktualisiert den Warenkorb basierend auf der Antwort des Servers
     */
    public updateFragments(response: any): void {
        if (response.cart_data) {
            // Update der DOM-Fragmente, wenn sie vorhanden sind
            //Todo Hier update der Sidecart elemente


            store.dispatch(setAllCartData(response.cart_data));


        /*    Object.entries(response.fragments).forEach(([selector, content]) => {
                const element = document.querySelector(selector);
                if (element) {
                    element.innerHTML = content as string;
                } else {
                    console.warn(`Element mit dem Selektor "${selector}" nicht gefunden.`);
                }
            });
            */
            if (this.supportsHTML5Storage) {

                const fragmentName = window.wc_cart_fragments_params.fragment_name;
                const cart_hash_key = window.wc_cart_fragments_params.cart_hash_key;
               // console.log("fragmentName new: ",fragmentName);
               // console.log("Cart-Hash-Key new: ",cart_hash_key);

                // Wenn wc_cart_fragments_params definiert ist, setze die Werte in den Storage
                if (typeof window.wc_cart_fragments_params !== 'undefined') {
                    //console.log("Update fragment storage Data");
                    const { fragment_name, cart_hash_key } = window.wc_cart_fragments_params;
                    //sessionStorage.setItem(fragment_name, JSON.stringify(response.fragments));
                    localStorage.setItem(cart_hash_key, response.cart_hash);
                    sessionStorage.setItem(cart_hash_key, response.cart_hash);

                    if (response.cart_hash) {
                        sessionStorage.setItem('wc_cart_created', (new Date()).getTime().toString());
                    }
                }
        } else {
            console.warn('HTML5-Storage wird nicht unterstützt.');
        }
                
        }
    }

    /**
     * Lädt die Warenkorb-Fragmente vom Server
     */
    public async refreshCartFragments(baseUrl: string): Promise<void> {
        try {
          //  console.log('Fetching cart fragments...');
            const response = await WoocommerceAPI.refreshCartFragments(baseUrl);

            if (response) {
            //    console.log('Cart fragments updated: ', response);
                this.updateFragments(response);
            }
        } catch (error) {
            console.error('Error refreshing cart fragments:', error);
        }
    }
}

export default UpdateSideCart;